import React from 'react';
import { Row } from 'react-bootstrap';
import { buildWhereForDates, FormCol, FormFilterCard, FieldDateRanger } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { FieldSelectCollector, FieldSelectDriver } from 'shared-pages';
import { useRootStore } from 'store';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'firstDate'),
      };
    }
    if (values.collectorId) where = { ...where, collectorId: values.collectorId };
    if (values.driverId) where = { ...where, driverId: values.driverId };
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  //
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
    collectorId: initialValues?.collectorId ?? undefined,
    driverId: initialValues?.driverId ?? undefined,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldDateRanger as={FormCol} label="Παραλαβή από" name="startDate" name2="endDate" />
        <FieldSelectCollector as={FormCol} name="collectorId" label={t('Συλλέκτης')} />
        <FieldSelectDriver as={FormCol} />
      </Row>
    </FormFilterCard>
  );
};
